import { IComponentOptions } from "angular";
import { RoleDetailUserComponentController } from "./controller";

export const vsComponentName = "roleDetailUsersComponent";

export const roleDetailUserComponentOptions: IComponentOptions = {
  controller: RoleDetailUserComponentController,
  controllerAs: "roleDetailUserComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
  },
};
